import React from 'react';
import styled from 'styled-components';

const OfertaContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 80px 20px;
  min-height: 70vh;
`;

const Title = styled.h1`
  text-align: center;
  color: #333;
  margin-bottom: 20px;
  font-size: 2.5rem;
  font-weight: 700;
`;

const Subtitle = styled.p`
  text-align: center;
  color: #666;
  margin-bottom: 60px;
  font-size: 1.2rem;
  max-width: 800px;
  margin: 0 auto 60px;
`;

const Section = styled.div`
  margin-bottom: 50px;
  background: #f8f9fa;
  padding: 40px;
  border-radius: 15px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
`;

const SectionTitle = styled.h2`
  color: #333;
  margin-bottom: 25px;
  font-size: 1.8rem;
  font-weight: 600;
`;

const SectionContent = styled.div`
  color: #555;
  line-height: 1.8;
  font-size: 1.1rem;
  
  p {
    margin-bottom: 15px;
  }
  
  ul, ol {
    margin: 15px 0;
    padding-left: 30px;
    
    li {
      margin-bottom: 10px;
    }
  }
  
  strong {
    color: #333;
    font-weight: 600;
  }
`;

const ImportantNote = styled.div`
  background: linear-gradient(135deg, #FF9800, #f57c00);
  color: white;
  padding: 30px;
  border-radius: 15px;
  margin-top: 40px;
`;

const NoteTitle = styled.h3`
  margin-bottom: 15px;
  font-size: 1.4rem;
`;

const NoteText = styled.p`
  line-height: 1.6;
  margin: 0;
`;

const ContactInfo = styled.div`
  background: #f8f9fa;
  padding: 30px;
  border-radius: 15px;
  text-align: center;
  margin-top: 40px;
`;

const ContactTitle = styled.h3`
  color: #333;
  margin-bottom: 20px;
  font-size: 1.4rem;
`;

const ContactItem = styled.div`
  margin-bottom: 15px;
  
  &:last-child {
    margin-bottom: 0;
  }
`;

const ContactLabel = styled.span`
  color: #555;
  margin-right: 10px;
`;

const ContactValue = styled.span`
  color: #4CAF50;
  font-weight: 600;
`;

const Oferta = () => {
  return (
    <OfertaContainer>
      <Title>Публичная оферта</Title>
      <Subtitle>
        Договор купли-продажи товаров дистанционным способом
      </Subtitle>

      <Section>
        <SectionTitle>1. Общие положения</SectionTitle>
        <SectionContent>
          <p>
            <strong>1.1.</strong> Настоящий документ является публичной офертой (далее – «Оферта») в адрес физических и юридических лиц (далее – «Покупатель») о заключении Договора купли-продажи товаров дистанционным способом (далее – «Договор») на условиях, изложенных ниже.
          </p>
          <p>
            <strong>1.2.</strong> В соответствии с пунктом 2 статьи 437 Гражданского кодекса Российской Федерации (далее – «ГК РФ») данный документ является публичной офертой, и в случае принятия изложенных ниже условий лицо, производящее акцепт этой оферты, становится Покупателем.
          </p>
          <p>
            <strong>1.3.</strong> Акцептом настоящей Оферты является оформление Покупателем заказа на Сайте или оплата Товара, указанного в заказе.
          </p>
          <p>
            <strong>1.4.</strong> Продавец – Общество с ограниченной ответственностью «Лагом Лайф» (далее – «Продавец»), расположенное по адресу: 446301, Самарская область, г. Отрадный, Спортивная ул., д. 7, ОГРН 1246300002409, ИНН 6318073403, КПП 637201001.
          </p>
          <p>
            <strong>1.5.</strong> Сайт – интернет-сайт, расположенный в сети Интернет по адресу https://foodstar.pro (далее – «Сайт»).
          </p>
          <p>
            <strong>1.6.</strong> Товар – продукция, представленная на Сайте и доступная для приобретения Покупателем.
          </p>
        </SectionContent>
      </Section>

      <Section>
        <SectionTitle>2. Предмет договора</SectionTitle>
        <SectionContent>
          <p>
            <strong>2.1.</strong> Продавец обязуется передать в собственность Покупателя Товар, а Покупатель обязуется принять и оплатить Товар на условиях настоящей Оферты.
          </p>
          <p>
            <strong>2.2.</strong> Наименование, ассортимент, артикул, цена, количество Товара, подлежащего передаче Покупателю, указываются в заказе Покупателя.
          </p>
          <p>
            <strong>2.3.</strong> Обязательства Продавца по передаче Товара считаются исполненными с момента передачи Товара Покупателю или уполномоченному им лицу.
          </p>
        </SectionContent>
      </Section>

      <Section>
        <SectionTitle>3. Цена товара и порядок расчетов</SectionTitle>
        <SectionContent>
          <p>
            <strong>3.1.</strong> Цена Товара указывается на Сайте в рублях Российской Федерации и включает в себя налог на добавленную стоимость.
          </p>
          <p>
            <strong>3.2.</strong> Цена Товара может быть изменена Продавцом в одностороннем порядке. При этом цена на заказанный Покупателем Товар изменению не подлежит.
          </p>
          <p>
            <strong>3.3.</strong> Стоимость доставки Товара указывается на Сайте и оплачивается Покупателем дополнительно к цене Товара, если иное не указано на Сайте.
          </p>
          <p>
            <strong>3.4.</strong> Оплата Товара производится следующими способами:
          </p>
          <ul>
            <li>Банковской картой через платежный шлюз на Сайте;</li>
            <li>Наличными денежными средствами при получении Товара (при доставке курьером);</li>
            <li>Иными способами, указанными на Сайте.</li>
          </ul>
          <p>
            <strong>3.5.</strong> Моментом оплаты считается поступление денежных средств на расчетный счет Продавца или в кассу Продавца.
          </p>
        </SectionContent>
      </Section>

      <Section>
        <SectionTitle>4. Порядок оформления и выполнения заказа</SectionTitle>
        <SectionContent>
          <p>
            <strong>4.1.</strong> Покупатель самостоятельно оформляет заказ на Сайте путем выбора Товара и добавления его в корзину, указания необходимых данных для доставки и оплаты.
          </p>
          <p>
            <strong>4.2.</strong> После оформления заказа Покупателю направляется подтверждение заказа на указанный при оформлении адрес электронной почты или номер телефона.
          </p>
          <p>
            <strong>4.3.</strong> Продавец вправе отказать Покупателю в подтверждении заказа в случае отсутствия Товара на складе, указания Покупателем недостоверных данных, а также в иных случаях, предусмотренных законодательством Российской Федерации.
          </p>
          <p>
            <strong>4.4.</strong> Срок выполнения заказа составляет от 1 до 10 рабочих дней с момента подтверждения заказа, если иное не указано на Сайте или не согласовано с Покупателем.
          </p>
        </SectionContent>
      </Section>

      <Section>
        <SectionTitle>5. Доставка товара</SectionTitle>
        <SectionContent>
          <p>
            <strong>5.1.</strong> Доставка Товара осуществляется следующими способами:
          </p>
          <ul>
            <li>Курьерской службой по адресу, указанному Покупателем при оформлении заказа (в пределах зоны доставки);</li>
            <li>Почтой России по адресу, указанному Покупателем при оформлении заказа;</li>
            <li>Самовывозом из пункта выдачи или розничного магазина Продавца.</li>
          </ul>
          <p>
            <strong>5.2.</strong> Стоимость доставки указывается на Сайте и оплачивается Покупателем дополнительно к цене Товара, если иное не указано на Сайте.
          </p>
          <p>
            <strong>5.3.</strong> Срок доставки Товара указывается на Сайте и зависит от выбранного способа доставки и региона доставки.
          </p>
          <p>
            <strong>5.4.</strong> Риск случайной гибели или случайного повреждения Товара переходит к Покупателю с момента передачи Товара Покупателю или уполномоченному им лицу.
          </p>
        </SectionContent>
      </Section>

      <Section>
        <SectionTitle>6. Права и обязанности сторон</SectionTitle>
        <SectionContent>
          <p>
            <strong>6.1. Продавец обязуется:</strong>
          </p>
          <ul>
            <li>Передать Покупателю Товар в количестве, ассортименте и по цене, соответствующих заказу Покупателя;</li>
            <li>Обеспечить доставку Товара в срок, указанный на Сайте или согласованный с Покупателем;</li>
            <li>Обеспечить качество Товара в соответствии с требованиями законодательства Российской Федерации.</li>
          </ul>
          <p>
            <strong>6.2. Покупатель обязуется:</strong>
          </p>
          <ul>
            <li>Своевременно оплатить Товар в порядке и на условиях, предусмотренных настоящей Офертой;</li>
            <li>Принять Товар в срок, указанный в заказе;</li>
            <li>Предоставить достоверные данные, необходимые для выполнения заказа.</li>
          </ul>
          <p>
            <strong>6.3. Покупатель вправе:</strong>
          </p>
          <ul>
            <li>Требовать от Продавца исполнения обязательств по настоящей Оферте;</li>
            <li>Отказаться от Товара до его передачи, а после передачи Товара – в порядке и на условиях, предусмотренных законодательством Российской Федерации.</li>
          </ul>
        </SectionContent>
      </Section>

      <Section>
        <SectionTitle>7. Ответственность сторон</SectionTitle>
        <SectionContent>
          <p>
            <strong>7.1.</strong> За неисполнение или ненадлежащее исполнение обязательств по настоящей Оферте стороны несут ответственность в соответствии с законодательством Российской Федерации.
          </p>
          <p>
            <strong>7.2.</strong> Продавец не несет ответственности за ущерб, причиненный Покупателю вследствие ненадлежащего использования Товара, приобретенного на Сайте.
          </p>
          <p>
            <strong>7.3.</strong> Продавец не несет ответственности за частичное или полное неисполнение обязательств по доставке Товара, если они являются следствием обстоятельств непреодолимой силы.
          </p>
        </SectionContent>
      </Section>

      <Section>
        <SectionTitle>8. Возврат товара</SectionTitle>
        <SectionContent>
          <p>
            <strong>8.1.</strong> Покупатель вправе отказаться от Товара в любое время до его передачи, а после передачи Товара – в течение 7 дней, не считая дня покупки, в порядке и на условиях, предусмотренных законодательством Российской Федерации.
          </p>
          <p>
            <strong>8.2.</strong> Возврат Товара надлежащего качества возможен при условии сохранения его товарного вида, потребительских свойств, а также документа, подтверждающего факт и условия покупки указанного Товара.
          </p>
          <p>
            <strong>8.3.</strong> Подробная информация о порядке и условиях возврата Товара размещена на Сайте по адресу https://foodstar.pro/vozvrat.
          </p>
        </SectionContent>
      </Section>

      <Section>
        <SectionTitle>9. Заключительные положения</SectionTitle>
        <SectionContent>
          <p>
            <strong>9.1.</strong> Настоящая Оферта вступает в силу с момента размещения на Сайте и действует до момента отзыва Оферты Продавцом.
          </p>
          <p>
            <strong>9.2.</strong> Продавец оставляет за собой право вносить изменения в настоящую Оферту без уведомления Покупателя. Новая редакция Оферты вступает в силу с момента ее размещения на Сайте.
          </p>
          <p>
            <strong>9.3.</strong> Все споры, возникающие из настоящей Оферты или в связи с ней, подлежат разрешению в соответствии с законодательством Российской Федерации.
          </p>
          <p>
            <strong>9.4.</strong> По всем вопросам, связанным с исполнением настоящей Оферты, Покупатель может обращаться к Продавцу по контактным данным, указанным на Сайте.
          </p>
        </SectionContent>
      </Section>

      <ImportantNote>
        <NoteTitle>Важная информация</NoteTitle>
        <NoteText>
          Совершая действия, направленные на акцепт настоящей Оферты (оформление заказа, оплата Товара), Покупатель подтверждает, что ознакомился, понял и полностью согласен со всеми условиями настоящей Оферты.
        </NoteText>
      </ImportantNote>

      <ContactInfo>
        <ContactTitle>Реквизиты Продавца</ContactTitle>
        <ContactItem>
          <ContactLabel>Наименование:</ContactLabel>
          <ContactValue>ООО "Лагом Лайф"</ContactValue>
        </ContactItem>
        <ContactItem>
          <ContactLabel>Адрес:</ContactLabel>
          <ContactValue>446301, Самарская область, г. Отрадный, Спортивная ул., д. 7</ContactValue>
        </ContactItem>
        <ContactItem>
          <ContactLabel>ИНН:</ContactLabel>
          <ContactValue>6318073403</ContactValue>
        </ContactItem>
        <ContactItem>
          <ContactLabel>КПП:</ContactLabel>
          <ContactValue>637201001</ContactValue>
        </ContactItem>
        <ContactItem>
          <ContactLabel>ОГРН:</ContactLabel>
          <ContactValue>1246300002409</ContactValue>
        </ContactItem>
        <ContactItem>
          <ContactLabel>Email:</ContactLabel>
          <ContactValue>lagomlife@mail.ru</ContactValue>
        </ContactItem>
      </ContactInfo>
    </OfertaContainer>
  );
};

export default Oferta;

